import { forwardRef, type ReactNode, type ComponentPropsWithoutRef } from 'react';
import { UnstyledButton } from '@mantine/core';
import classes from './MarketplaceTabs.module.css';
import { getMarketplaceToolbarStyleVars } from './marketplaceTabStyleVars';

type MarketplaceToolbarButtonProps = ComponentPropsWithoutRef<'button'> & {
  accentColor: string;
  active?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  /** Hide label on narrow layouts (icon-only chip). */
  hideLabel?: boolean;
  /** Optional count badge (e.g. active filter count). */
  badge?: number | string;
  children?: ReactNode;
};

export const MarketplaceToolbarButton = forwardRef<HTMLButtonElement, MarketplaceToolbarButtonProps>(
  function MarketplaceToolbarButton(
    {
      accentColor,
      active = false,
      leftIcon,
      rightIcon,
      hideLabel = false,
      badge,
      children,
      className,
      style,
      type = 'button',
      ...rest
    },
    ref
  ) {
    const showLabel = !hideLabel && children != null && children !== false;

    return (
      <UnstyledButton
        ref={ref}
        type={type}
        className={`${classes.toolbarButton} ${active ? classes.toolbarButtonActive : ''}${className ? ` ${className}` : ''}`}
        style={{ ...getMarketplaceToolbarStyleVars(accentColor), ...style }}
        {...rest}
      >
        <span className={classes.toolbarInner}>
          <span className={classes.toolbarMain}>
            {leftIcon ? <span className={classes.toolbarIcon}>{leftIcon}</span> : null}
            {showLabel ? <span className={classes.tabLabelText}>{children}</span> : null}
          </span>
          {badge != null && badge !== '' && Number(badge) !== 0 ? (
            <span className={classes.toolbarBadge}>{badge}</span>
          ) : null}
          {rightIcon ? <span className={classes.toolbarChevron}>{rightIcon}</span> : null}
        </span>
      </UnstyledButton>
    );
  }
);
